import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { EventService } from "~app/common/services/cqs/event.service";
import {
    DestineringsraderUpdatedEvent
} from "~app/features/transport/transportplanera/components/tpl-omdestinera/components/begransa-virkesorderrader-modal/begransa-virkesorderrader-events";
import {
    RuttChangedEvent,
    RuttExtraKmChangedEvent,
    AnvandVerkligaAvlaggChangedEvent
} from "~app/features/transport/transportplanera/components/tpl-transportavstand-modal/tpl-transportavstand-eventhandler";
import { ArbetsorderHandelssortimentAddedEventMessage } from "../events/ArbetsorderHandelssortimentAddedEventMessage";
import { ArbetsorderHandelssortimentDeletedEventMessage } from "../events/ArbetsorderHandelssortimentDeletedEventMessage";
import * as DestineringEvents from "../events/DestineringAttributEventMessage";
import { DestineringsalternativMergeCompletedEventMessage } from "../events/DestineringsalternativMergeCompletedEventMessage";
import { TransportavstandBerakningCompletedEventMessage } from "../events/TransportavstandBerakningCompletedEventMessage";

export class EventHandler {

    private readonly ngUnsubscribe$ = new Subject<void>();

    constructor(
        private readonly arbetsorderId: number,
        private readonly eventService: EventService) { }

    onArbetsorderHandelssortimentAdded(callback: (e: ArbetsorderHandelssortimentAddedEventMessage) => void) {
        this.eventService
            .subscribeEvent<ArbetsorderHandelssortimentAddedEventMessage>(ArbetsorderHandelssortimentAddedEventMessage.$type)
            .pipe(
                takeUntil(this.ngUnsubscribe$),
                filter(event => event.arbetsorderId === this.arbetsorderId)
            )
            .subscribe((event) => callback(event));
    }

    onArbetsorderHandelssortimentDeleted(callback: (e: ArbetsorderHandelssortimentDeletedEventMessage) => void): void {
        this.eventService
            .subscribeEvent<ArbetsorderHandelssortimentDeletedEventMessage>(ArbetsorderHandelssortimentDeletedEventMessage.$type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .pipe(filter(event => event.arbetsorderId === this.arbetsorderId))
            .subscribe(event => callback(event));
    }

    onVirkesorderValidation(callback: (e: DestineringEvents.DestineringAttributEventMessage) => void): void {
        this.eventService
            .subscribeEvent<DestineringEvents.DestineringAttributEventMessage>(DestineringEvents.DestineringAttributEventMessage.$type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .pipe(filter(event => event.arbetsorderId === this.arbetsorderId))
            .pipe(filter(event => event.grupp === DestineringEvents.DestineringAttributGrupper.VirkesorderValidation))
            .pipe(filter(event => event.nyckel === DestineringEvents.DestineringAttributVirkesorderValidationNycklar.GenericMessages))
            .subscribe(event => callback(event));
    }

    onDestineringsalternativMergeCompleted(callback: (e: DestineringsalternativMergeCompletedEventMessage) => void): void {
        this.eventService
            .subscribeEvent<DestineringsalternativMergeCompletedEventMessage>(DestineringsalternativMergeCompletedEventMessage.$type)
            .pipe(
                takeUntil(this.ngUnsubscribe$),
                filter(event => event.arbetsorderId === this.arbetsorderId))
            .subscribe(event => callback(event));
    }

    onTransportavstandBerakningCompleted(callback: (e: TransportavstandBerakningCompletedEventMessage) => void): void {
        this.eventService
            .subscribeEvent<TransportavstandBerakningCompletedEventMessage>(TransportavstandBerakningCompletedEventMessage.$type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .pipe(filter(event => event.arbetsorderId === this.arbetsorderId))
            .subscribe(event => callback(event));
    }

    onRuttChanged(callback: (e: RuttChangedEvent) => void) {
        this.eventService
            .subscribeEvent<RuttChangedEvent>(RuttChangedEvent.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => callback(event));
    }

    onRuttExtraKmChanged(callback: (e: RuttExtraKmChangedEvent) => void) {
        this.eventService
            .subscribeEvent<RuttExtraKmChangedEvent>(RuttExtraKmChangedEvent.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => callback(event));
    }

    onDestineringraderUpdated(callback: (e: DestineringsraderUpdatedEvent) => void) {
        this.eventService
            .subscribeEvent<DestineringsraderUpdatedEvent>(DestineringsraderUpdatedEvent.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => callback(event));
    }

    onAnvandVerkligaAvlaggChanged(callback: (e: AnvandVerkligaAvlaggChangedEvent) => void) {
        this.eventService
            .subscribeEvent<AnvandVerkligaAvlaggChangedEvent>(AnvandVerkligaAvlaggChangedEvent.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => callback(event));
    }

    unsubscribe(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}
